import { GridRowModel } from '@mui/x-data-grid';
import { MAX_ENTITIES_NUMBER_PER_REQUEST } from 'common/constants/exportData';

type  APIResponse = {
    data: GridRowModel[],
    skipped: number,
    taken: number
};

export const mergeResults = (results: APIResponse[]): GridRowModel[] =>{
    results.sort((a, b) => {
        if (a.skipped === b.skipped) {
            return a.taken - b.taken;
        }
        return a.skipped - b.skipped;
    });

    return results.flatMap(obj => obj.data);
};

export const getNumberOfRequests = (rowsCount?: number, maxNumberOfEntitiesPerRequest? : number): number =>{
    return Math.ceil((rowsCount ?? 1 ) / (maxNumberOfEntitiesPerRequest ?? MAX_ENTITIES_NUMBER_PER_REQUEST));
};
